import React, { useEffect, useRef, useState } from 'react';

import './popup.css';

const PopUp = () => {
    const [showPopup, setShowPopup] = useState(true);

    const popupRef = useRef();
    const timer = useRef();

    useEffect(() => {
        const showPopUp = () => {
            timer.current = setTimeout(() => {
                popupRef.current.classList.add('show');
            }, 2000);
        };

        window.addEventListener('load', showPopUp);

        return () => {
            clearTimeout(timer);
            window.removeEventListener('load', showPopUp);
        };
    }, [showPopup]);

    return (
        <>
            {showPopup && (
                <div ref={popupRef} className="popup">
                    <div className="popup__content d-flex">
                        <div className="left w-50">
                            <div className="left__img w-100 ">
                                <img
                                    src="https://d3k81ch9hvuctc.cloudfront.net/company/V9Jdeu/images/43edd71c-2a4a-4d25-9991-383b58f27602.png"
                                    alt="popup"
                                    className="w-100"
                                />
                            </div>
                        </div>
                        <div className="right w-50 ">
                            <span className="closeBtn" onClick={() => setShowPopup(false)}>
                                <i className="ri-close-fill"></i>
                            </span>
                            <div className="text__voucher">
                                <h3>Best food, Best Restaurant</h3>
                                <p className="text-mid">UNLOCK</p>
                                <p className="text-big">20% OFF</p>
                                <p className="text-mid">Your First Online Order</p>
                            </div>

                            <div className="submit">
                                <input autoFocus type="email" placeholder="Your email address" />
                                <button className="btn rev">Get voucher</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default PopUp;
